import { dynamicZoom, defaultZoom, zoomOrientationReference } from '../constants/constants';

// Le zoom est une préférence d'affichage PAR NAVIGATEUR (par utilisateur),
// pas un état du document : il ne doit être ni synchronisé entre co-éditeurs,
// ni persisté dans le content, ni réinitialisé au changement de document.
// Source de vérité : localStorage. Réactivité : champ store `zoomLevel`
// (top-level, hors whitelist du diff → naturellement exclu de la collab).
const STORAGE_KEY = 'editorZoomLevel';

// Valeur explicitement choisie par l'utilisateur, ou null (→ dynamicZoom).
export const readStoredZoom = () => {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (raw == null) return null;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
};

export const writeStoredZoom = (value) => {
  if (value == null) window.localStorage.removeItem(STORAGE_KEY);
  else window.localStorage.setItem(STORAGE_KEY, String(value));
};

// Zoom effectif : choix utilisateur, sinon zoom adapté à l'écran, sinon défaut.
export const resolveZoom = (zoomLevel) =>
  zoomLevel || dynamicZoom() || defaultZoom;

// Échelle CSS réellement appliquée au document. Le pourcentage choisi/stocké
// (identique à celui affiché dans le sélecteur, cf. resolveZoom) est rebasé
// sur le point de référence par orientation (zoomOrientationReference) : 100 %
// applique cette échelle de référence au lieu d'un 1:1 brut. Ne modifie ni le
// store ni la valeur persistée, uniquement le mapping pourcentage → échelle.
export const effectiveZoom = (zoomLevel, landscape) =>
  (resolveZoom(zoomLevel) *
    (landscape ? zoomOrientationReference.landscape : zoomOrientationReference.portrait)) /
  100;
